import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { FileServiceConfig } from './file-service.types';

export function provideFileService(config: FileServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'fileServiceConfig', useValue: config }
  ]);
}
